import React, { useEffect, useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import CloudUploadOutlinedIcon from "@mui/icons-material/CloudUploadOutlined";

function EditFabricModal({ show, onHide, fabric, onSave, saving }) {
  const [nameInput, setNameInput] = useState("");
  const [priceInput, setPriceInput] = useState("0");
  const [originPriceInput, setOriginPriceInput] = useState("0");
  const [pricePerRollInput, setPricePerRollInput] = useState("0");
  const [originPricePerRollInput, setOriginPricePerRollInput] = useState("0");
  const [amountRollInput, setAmountRollInput] = useState("0");
  const [qtyPerRollInput, setQtyPerRollInput] = useState("0");
  const [imageFile, setImageFile] = useState();
  const [imagePreview, setImagePreview] = useState("");

  useEffect(() => {
    if (!show) {
      return;
    }
    setNameInput(fabric?.name || "");
    setPriceInput(String(fabric?.price ?? 0));
    setOriginPriceInput(String(fabric?.originPrice ?? 0));
    setPricePerRollInput(String(fabric?.pricePerRoll ?? 0));
    setOriginPricePerRollInput(String(fabric?.originPricePerRoll ?? 0));
    setAmountRollInput(String(fabric?.amountRoll ?? 0));
    setQtyPerRollInput(String(fabric?.qtyPerRoll ?? 0));
    setImageFile(undefined);
    setImagePreview(fabric?.imageSrc || "");
  }, [show, fabric]);

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>ແກ້ໄຂປະເພດຜ້າ</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form.Group>
          <Form.Label>ອັບໂຫລດຮູບຜ້າ</Form.Label>
          <Form.Control
            id="edit-fabric-file-upload"
            type="file"
            accept="image/*"
            multiple={false}
            hidden
            onChange={(e) => {
              const file = e.target.files?.[0];
              setImageFile(file);
              setImagePreview(file ? URL.createObjectURL(file) : "");
            }}
          />
          <label htmlFor="edit-fabric-file-upload" style={{ margin: 0, width: "100%" }}>
            <div
              style={{
                backgroundColor: "#F9FAFB",
                height: 250,
                width: "100%",
                border: "1px dashed #93989F",
                borderRadius: 8,
                cursor: "pointer",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {imagePreview ? (
                <img src={imagePreview} alt="edit-fabric-preview" style={{ width: "100%", height: "100%", objectFit: "cover", borderRadius: 8 }} />
              ) : (
                <>
                  <CloudUploadOutlinedIcon sx={{ fontSize: 36, color: "#93989F" }} />
                  <p style={{ color: "#93989F", marginTop: 8, marginBottom: 4 }}>ເພີ່ມຮູບຜ້າ</p>
                  <p style={{ color: "#3C169B", textDecoration: "underline", marginBottom: 0 }}>Browse</p>
                </>
              )}
            </div>
          </label>
          <p style={{ color: "#93989F", marginTop: 8, marginBottom: 0 }}>ກົດຮູບອີກເທື່ອ ເພື່ອປ່ຽນຮູບ</p>
        </Form.Group>

        <div className="mt-3" style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
          <Form.Group>
            <Form.Label>ລາຄາຂາຍ (ຕໍ່ໂຕ)</Form.Label>
            <Form.Control 
              type="number" 
              min={0} 
              style={{ background: "#FDF2F8" }}
              value={priceInput} 
              onChange={(e) => {
                  const price = parseFloat(e.target.value || 0);
                  setPriceInput(e.target.value);
                  const qty = parseFloat(qtyPerRollInput || 1);
                  if (qty > 0) setPricePerRollInput(Math.ceil(price * qty).toString());
              }} 
              placeholder="0" 
            />
          </Form.Group>
          <Form.Group>
            <Form.Label>ລາຄາຕົ້ນທຶນ (ຕໍ່ກໍ້)</Form.Label>
            <Form.Control 
              type="number" 
              min={0} 
              style={{ background: "#F0F9FF" }}
              value={originPricePerRollInput} 
              onChange={(e) => {
                  const opRoll = parseFloat(e.target.value || 0);
                  setOriginPricePerRollInput(e.target.value);
                  const qty = parseFloat(qtyPerRollInput || 1);
                  if (qty > 0) setOriginPriceInput(Math.ceil(opRoll / qty).toString());
              }} 
              placeholder="0" 
            />
          </Form.Group>
        </div>

        <div className="mt-3" style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
          <Form.Group>
            <Form.Label>ຈຳນວນກໍ້ຜ້າ</Form.Label>
            <Form.Control type="number" min={0} value={amountRollInput} onChange={(e) => setAmountRollInput(e.target.value)} placeholder="0" />
          </Form.Group>
          <Form.Group>
            <Form.Label>ຈຳນວນເສື້ອ,ໂສ້ງ/ຜ້າ1ກໍ້</Form.Label>
            <Form.Control 
              type="number" 
              min={0} 
              value={qtyPerRollInput} 
              onChange={(e) => {
                  const g = parseFloat(e.target.value || 0);
                  setQtyPerRollInput(e.target.value);
                  if (g > 0) {
                      setPricePerRollInput(Math.ceil(parseFloat(priceInput || 0) * g).toString());
                      setOriginPriceInput(Math.ceil(parseFloat(originPricePerRollInput || 0) / g).toString());
                  }
              }} 
              placeholder="0" 
            />
          </Form.Group>
        </div>
        <p style={{ color: "#93989F", marginTop: 8, marginBottom: 0, fontSize: "0.85rem" }}>
          ໝາຍເຫດ: ຜ້າ1ກໍ້ ໄດ້ຈຳນວນເສື້ອຈັກຜືນ
        </p>
        <Form.Group className="mt-3">
          <Form.Label>ຊື່ປະເພດຜ້າ</Form.Label>
          <Form.Control value={nameInput} onChange={(e) => setNameInput(e.target.value)} placeholder="ປ້ອນຊື່ຜ້າ" />
        </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          ຍົກເລີກ
        </Button>
        <Button
          variant="primary"
          disabled={saving}
          onClick={() =>
            onSave({
              id: fabric?.id,
              name: nameInput.trim(),
              price: Number(priceInput || 0),
              originPrice: Number(originPriceInput || 0),
              pricePerRoll: Number(pricePerRollInput || 0),
              originPricePerRoll: Number(originPricePerRollInput || 0),
              amountRoll: Number(amountRollInput || 0),
              qtyPerRoll: Number(qtyPerRollInput || 0),
              imageFile,
            })
          }
        >
          ບັນທຶກ
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default EditFabricModal;
